/// <reference types="vite/client" />
/**
 * Centralized configuration for the web frontend.
 * This handles environment-specific API endpoints.
 */

/** MeshGen app version shown in header (source of truth: `@/lib/appVersion`). */
import { APP_VERSION } from '@/lib/appVersion';
export { APP_VERSION };

/** Stytch session duration used across all auth entry points (login, reset, refresh). */
export const SESSION_DURATION_MINUTES = 360;

const ALB_DNS = 'webdev-alb-1882895883.us-west-1.elb.amazonaws.com';
const PUBLIC_IP = '54.183.252.115';

/**
 * `VITE_API_URL` when the build sets one (every deployed `.env.<mode>` does),
 * else the same-origin `/api` that the dev server proxies. The hostname is
 * deliberately not consulted: the old substring checks on it served an S3
 * website bucket no stack deploys, and matched lookalike hosts too.
 */
function getApiBase(): string {
  // An explicit VITE_API_URL wins, and vite.config.ts's
  // `khorium:auth-api-preconnect` plugin relies on that: it warms the origin
  // of VITE_API_URL at build time. Demote this check and the preconnect
  // silently points at the wrong origin — update both together.
  const envUrl = import.meta.env.VITE_API_URL;
  if (typeof envUrl === 'string' && envUrl) return envUrl;
  return '/api';
}

export const API_BASE: string = getApiBase();

/** Base URL for the KhoriumAgents service. Empty string → relative (Vite /agent proxy handles dev). */
export const AGENT_BASE: string = import.meta.env.VITE_AGENT_URL ?? '';

// NB: boot diagnostics for API_BASE/hostname are emitted from `main.tsx` via the
// structured logger. This module stays a dependency-free leaf so `@/lib/logger`
// (which reads APP_VERSION here) can import it without an import cycle.

export interface ConfigExport {
  API_BASE: string;
  ALB_DNS: string;
  PUBLIC_IP: string;
  APP_VERSION: string;
}

const config: ConfigExport = {
  API_BASE,
  ALB_DNS,
  PUBLIC_IP,
  APP_VERSION,
};

export default config;
